import { render, staticRenderFns } from "./BulletinCenter.vue?vue&type=template&id=f5340486&scoped=true&"
import script from "./BulletinCenter.vue?vue&type=script&lang=js&"
export * from "./BulletinCenter.vue?vue&type=script&lang=js&"
import style0 from "./BulletinCenter.vue?vue&type=style&index=0&id=f5340486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5340486",
  null
  
)

export default component.exports